export enum TipoAcumulacionEnum {
    DINERO = "DINERO",
    HORAS = "HORAS",
    DIAS = "DIAS"
}